import { Bike16, Bus16, MetroMoscow16, Parking16 } from '@cian/ui-kit';

import { IconCompetitor16 } from 'shared/components/Icons/IconCompetitor16';
import { IconScooter16 } from 'shared/components/Icons/IconScooter16';
import { IconStreetCar16 } from 'shared/components/Icons/IconStreetCar16';
import { IMapRowsProps } from 'shared/components/MapRows';
import { getAvailableOutsideInfrastructureTypes } from 'shared/containers/NewbuildingMapContainer/utils/transportAccessibility';
import { EOutsideTAInfrastructureType, ITAInfrastructure } from 'shared/types/map';

const INFRASTRUCTURE_TYPES: Record<
  EOutsideTAInfrastructureType,
  {
    text: string;
    IconComponent: React.FunctionComponent;
  }
> = {
  [EOutsideTAInfrastructureType.busStops]: {
    text: 'Автобусы',
    IconComponent: Bus16,
  },
  [EOutsideTAInfrastructureType.tramStops]: {
    text: 'Трамваи',
    IconComponent: IconStreetCar16,
  },
  [EOutsideTAInfrastructureType.metro]: {
    text: 'Метро',
    IconComponent: MetroMoscow16,
  },
  [EOutsideTAInfrastructureType.parking]: {
    text: 'Парковки',
    IconComponent: Parking16,
  },
  [EOutsideTAInfrastructureType.bikeParking]: {
    text: 'Велопарковки',
    IconComponent: Bike16,
  },
  [EOutsideTAInfrastructureType.chargingStations]: {
    text: 'Станции зарядки электромобилей',
    IconComponent: IconCompetitor16,
  },
  [EOutsideTAInfrastructureType.scooterParking]: {
    text: 'Парковки для самокатов',
    IconComponent: IconScooter16,
  },
};

export const getOutsideRows = (
  transportAccessibilityInfrastructure: ITAInfrastructure | undefined,
): IMapRowsProps['items'] => {
  const availableInfrastructureTypes = getAvailableOutsideInfrastructureTypes(transportAccessibilityInfrastructure);

  return availableInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPES[type],
  }));
};
